import {
  fcheck_null_undefine_replace_empty,
  fAlertToast,
} from "../../Utility/Utilitys";

import { vRdxUserInfo } from "../../Redux/roStore";
import {
  common_groupstructure_GETROW,
  common_brandgroup_GETROW,
  common_brandbasedgroup_GETROW,
  common_LocationSearch_GETROW,
  common_VendorListReport_GETROW,
  common_ItemsSearchReport_GETROW,
} from "../../Server/ApiV2";
import { fExecuteAPI } from "../../Server/Apis.jsx";

export const sWebStockReportData = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
];
export const sWebStockReportArr = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
  { Uid: "From", Value: "From" },
  { Uid: "To", Value: "To" },
  { Uid: "Between", Value: "Between" },
];
export const sWebBetweenReportArr = [{ Uid: "Between", Value: "Btwn" }];

export const HeadObjectInit = {
  sReportType: "DC_ITEMS",
  sDCItems: "B",
  sListedCheckBox: "B",
  sStock: "N",
  sConsumption: "N",
  sProjection: "N",
  sLocation: "Is",
  sMainGroup: "All",
  sSubGroup: "All",
  sCategory: "All",
  sMainSupplier: "All",
  sBrand: "All",
  sItem: "All",
  sBin: "All",
  sLocationArr: [],
  sLocationPrnt: "",
  sLocationCode: "",
  sLocationName: "",
  sMainGroupArr: [],
  sMainGroupPrnt: "",
  sMainGroupCode: "",
  sMainGroupName: "",
  sSubGroupArr: [],
  sSubGroupPrnt: "",
  sSubGroupCode: "",
  sSubGroupName: "",
  sCategoryArr: [],
  sCategoryPrnt: "",
  sCategoryCode: "",
  sCategoryName: "",
  sMainSupplierArr: [],
  sMainSupplierPrnt: "",
  sMainSupplierCode: "",
  sMainSupplierName: "",
  sSupplierSearchValue: "",
  sBrandArr: [],
  sBrandPrnt: "",
  sBrandCode: "",
  sBrandName: "",
  sBrandSearchValue: "",
  sBrandCategoryArr: [],
  sBrandCategoryPrnt: "",
  sBrandCategoryCode: "",
  sBrandCategoryName: "",
  sItemCode: "",
  sItemName: "",
};

export const fWmsStockRepotArr = async (xGroupStructureObj, setGroupData) => {
  let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
  const CurrentMaingroupArr = await common_groupstructure_GETROW(FinalObj);
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
export const fWmsStockRepotBrandArr = async (
  xGroupStructureObj,
  setGroupData
) => {
  let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
  const CurrentMaingroupArr = await common_brandbasedgroup_GETROW(FinalObj);
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
export const GetWmsStockRepotBrand = async (setGroupData) => {
  const CurrentMaingroupArr = await common_brandgroup_GETROW("");
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
export const GetWmsStockRepotMainSupplier = async (setGroupData) => {
  const CurrentMaingroupArr = await common_VendorListReport_GETROW("");
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};

export const fWmsStockRepotHeadObj = async (
  xGroupStructureObj,
  setHeadObject,
  xkey
) => {
  let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
  const CurrentMaingroupArr = await common_groupstructure_GETROW(FinalObj);
  if (CurrentMaingroupArr?.status === 200) {
    setHeadObject((obj) => ({
      ...obj,
      xkey: CurrentMaingroupArr?.data?.ResultSet,
    }));
  }
};

export const GetLocation = async (setLocation) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  //v_AnyData,v_Cd,v_Name,v_Distri,v_UserCd
  var vLocobj = {
    v_AnyData: "",
    v_Cd: "",
    v_Name: "",
    v_Distri: "N",
    v_UserCd: vRdxUserInfoObj.UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLocobj);
  const vLocation = await common_LocationSearch_GETROW(FinalObj);
  if (vLocation?.status === 200) {
    setLocation(vLocation?.data?.ResultSet);
  }
};

export const GetItemFullSearchArr = async (xItemName) => {
  // let vItemFullSearchDataObj = {
  //   v_AnyData: xItemName,
  //   v_TransType: "F",
  //   v_Report: "Y",
  // };
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: "", //by sir
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    FinalObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull.Type.response.data.message
        ? vItemSearchFull.Type.response.data.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};
export const GetSearchItem = async (xData, xType, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: "", //by sir
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await common_ItemsSearchReport_GETROW(FinalObj);
  if (vItemSearch?.status === 200) {
    let vItemSearchArr = vItemSearch?.data?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};
export const fValidationHead_Client = (HeadObject) => {
  let iRes = true;

  if (
    HeadObject.sReportType === "" ||
    HeadObject.sReportType === null ||
    HeadObject.sReportType === undefined
  ) {
    fAlertToast("FAILED", "Report Type should not be empty");

    iRes = false;
    return iRes;
  }
  if (HeadObject.sReportType === "DC_ITEMS" && HeadObject.sDCItems === "") {
    fAlertToast("FAILED", "Select DCItems  ");

    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sReportType === "LISTED" &&
    HeadObject.sListedCheckBox === ""
  ) {
    fAlertToast("FAILED", "Select Listed");

    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sDCItems === "" &&
    HeadObject.sDCItems === null &&
    HeadObject.sDCItems === undefined
  ) {
    fAlertToast("FAILED", "DC Items  should not be empty");

    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sListedCheckBox === "" &&
    HeadObject.sListedCheckBox === null &&
    HeadObject.sListedCheckBox === undefined
  ) {
    fAlertToast("FAILED", "Listed should not be empty");

    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sStock === "" ||
    HeadObject.sStock === null ||
    HeadObject.sStock === undefined
  ) {
    fAlertToast("FAILED", "Stock Type should not be empty");

    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sConsumption === "" ||
    HeadObject.sConsumption === null ||
    HeadObject.sConsumption === undefined
  ) {
    fAlertToast("FAILED", "Consumption Type should not be empty");

    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sProjection === "" ||
    HeadObject.sProjection === null ||
    HeadObject.sProjection === undefined
  ) {
    fAlertToast("FAILED", "Projection Type should not be empty");

    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sLocation.toUpperCase() === "IS" &&
    HeadObject.sLocationPrnt === ""
  ) {
    fAlertToast("FAILED", "Location should not be empty");

    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sMainGroup.toUpperCase() === "IS" &&
    HeadObject.sMainGroupPrnt === ""
  ) {
    fAlertToast("FAILED", "MainGroup should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sSubGroup.toUpperCase() === "IS" &&
    HeadObject.sSubGroupPrnt === ""
  ) {
    fAlertToast("FAILED", "sSubGroup should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sCategory.toUpperCase() === "IS" &&
    HeadObject.sCategoryPrnt === ""
  ) {
    fAlertToast("FAILED", "sCategory should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sMainSupplier.toUpperCase() === "IS" &&
    HeadObject?.sMainSupplierArr.map((x) => x.AcCd).join(",") === ""
  ) {
    fAlertToast("FAILED", "sMainSupplier should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sBrand.toUpperCase() === "IS" &&
    HeadObject?.sBrandArr.map((x) => x.UID).join(",") === ""
  ) {
    fAlertToast("FAILED", "sBrand should not be empty");
    iRes = false;
    return iRes;
  }
  // if (
  //   HeadObject.sBrand.toUpperCase() === "IS" &&
  //   HeadObject.sBrandCategoryPrnt === ""
  // ) {
  //   fAlertToast("FAILED", "sBrandCategory should not be empty");
  //   iRes = false;
  //   return iRes;
  // }
  if (HeadObject.sItem.toUpperCase() === "IS" && HeadObject.sItemCode === "") {
    fAlertToast("FAILED", "sItemCode should not be empty");
    iRes = false;
    return iRes;
  }
  if (HeadObject.sItem.toUpperCase() === "IS" && HeadObject.sItemName === "") {
    fAlertToast("FAILED", "sItemName should not be empty");
    iRes = false;
    return iRes;
  }

  return iRes;
};
